import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from './tokens';
import { GlobalStyle } from './GlobalStyle';

/**
 * Wraps the app with:
 *   1. styled-components' ThemeProvider (so any styled component can read
 *      `props.theme.color.red[600]` etc.)
 *   2. The GlobalStyle block (declares CSS custom properties on :root and
 *      mounts the grain/halftone overlay pseudo-elements - invisible at
 *      Phase 1, driven by --grain-opacity in Phase 2+).
 *
 * Usage: mount once at the root in `client/src/index.js`:
 *   <ThemeProvider>
 *     <App />
 *   </ThemeProvider>
 */
export const ThemeProvider = ({ children }) => (
    <StyledThemeProvider theme={theme}>
        <GlobalStyle />
        {children}
    </StyledThemeProvider>
);

export default ThemeProvider;
